import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import PropTypes from 'prop-types'
import { loadRdsPartners } from '../../actions/rdsPartners'

class TimeZoneSelector extends React.Component {

  constructor(props) {
    super(props)
    this.showTimeZonesSelect = this.showTimeZonesSelect.bind(this)
    this.getDefaultOptions = this.getDefaultOptions.bind(this)
    this.state = {
    }
  }

  showTimeZonesSelect() {
    if (this.props.timeZones === null ? false : this.props.timeZones.length > 1)
    {
      return true
    }
    else
    {
      if (this.props.timeZone !== null && this.props.timeZone !== undefined && this.props.timeZone !== "")
      {
        let timeZone = this.props.timeZones.find((timeZone) => timeZone === this.props.timeZone)
        if (timeZone === undefined)
        {
          return  true
        }
      }
    }
    return false
  }

  componentDidMount() {
    this.props.loadRdsPartners()
  }

  getDefaultOptions()
  {
    let options =  null
    if (this.props.timeZone !== null && this.props.timeZone !== undefined && this.props.timeZone !== "")
    {
      let timeZone = this.props.timeZones.find((timeZone) => timeZone === this.props.timeZone)
      if (timeZone === undefined)
      {
        options = <option key={this.props.timeZone} value={this.props.timeZone}>{this.props.timeZone}</option>
      }
    }
    return options
  }

  render() {
    return <div className="form-group">
      <label htmlFor="timezone">Timezone</label>
      {this.showTimeZonesSelect() ?
        <select className="form-control"
          disabled={this.props.disabled}
          value={this.props.timeZone}
          onChange={(event) => {
            let val = event.target.value
            this.props.onChange(val)
          }} >
          {this.getDefaultOptions()}
          {this.props.timeZones.map((timeZone) => <option key={timeZone} value={timeZone}>{timeZone}</option>)}
        </select>
        :
        <input className="form-control" value={this.props.timeZone} id="timezone" disabled />
      }
    </div>
  }
}

TimeZoneSelector.propTypes = {
  onChange: PropTypes.func.isRequired,
  timeZones: PropTypes.arrayOf(PropTypes.string),
  timeZone: PropTypes.string,
  loadRdsPartners: PropTypes.func.isRequired,
  disabled: PropTypes.bool
}

TimeZoneSelector.defaultProps = {
  timeZones: [],
  timeZone: '',
  disabled: false
}


const mapStateToProps = (state, props) => {
  return {
    ...props,
    timeZones: state.system.timeZones,
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({
  loadRdsPartners
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(TimeZoneSelector)



// WEBPACK FOOTER //
// ./src/components/timeZoneSelector/index.js